import React, { CSSProperties } from 'react';

import SaralLoaderImage from '../SaralLoaderImage';

interface MainFallbackLoaderProps {
  style?: CSSProperties;
}

const MainFallbackLoader: React.FC<MainFallbackLoaderProps> = ({ style }) => {
  return (
    <div className="saral-main-loader" style={style}>
      <SaralLoaderImage />
    </div>
  );
};

export default MainFallbackLoader;
